/* BG COM : prix pro, une seule présentation (snippets/bgcom-pro-price : voir l'en-tête du snippet pour le contrat).
   04/10/2026 (vitesse r5.1) : sorti du snippet (10 Ko en ligne sur chaque page) vers cet asset en defer, en cache. Tous les appelants
   (samita-custom au DOMContentLoaded et ses minuteries, aperçu rapide, aperçu de lien, tref-pricing, hook-picker, variant-picker) testent
   window.bgcomProRows / bgcomProBadge / bgcomProFmt au moment de peindre, après DOMContentLoaded : un script defer est exécuté avant. */
(function () {
  'use strict';
  if (window.bgcomProRows) return;
  var d = document, root = d.documentElement;
  var MINUS = '\u2212', NNBSP = '\u202F';
  var GLYPH = '<svg class="bgp-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 0C12.7 7.2 16.2 11.2 22 12C16.2 12.8 12.7 16.8 12 24C11.3 16.8 7.8 12.8 2 12C7.8 11.2 11.3 7.2 12 0Z"/></svg>';

  /* the shop's money format, exactly as Liquid's money filter prints it: €1.234,50 */
  function fmt(c) {
    var n = Math.max(0, Math.round(+c || 0));
    return '\u20ac' + String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + ('0' + (n % 100)).slice(-2);
  }
  /* the pill: identical to the Liquid branch of this snippet */
  function badge(pct, key) {
    var p = Math.round(+pct) || 0;
    if (p <= 0) return '';
    return '<span class="bgp-badge" data-bgp-key="' + (Math.round(+key) || 0) + '">' + GLYPH +
      '<span aria-hidden="true">' + MINUS + p + NNBSP + '% PRO</span><span class="bgp-sr">remise pro de ' + p + ' %</span></span>';
  }
  /* the ordinary promotion pill (compare-at price, no pro discount): blue, no star, no PRO, never sparkles.
     Identical to the Liquid branch `sale:` of this snippet. */
  function sale(pct) {
    var p = Math.round(+pct) || 0;
    if (p <= 0) return '';
    return '<span class="bgp-badge bgp-badge--sale"><span aria-hidden="true">' + MINUS + p + NNBSP + '%</span><span class="bgp-sr">promotion de ' + p + ' %</span></span>';
  }
  /* the two rows every renderer paints. ht = the HT price shown, in cents; orig = the public HT price in cents when ht is
     a pro price, else 0; cmp (optional) = the compare-at HT price of an ordinary promotion, used only without a pro
     discount (the pro wins). TTC = round(ht x 1.2). Guest output without cmp = the renderers' previous guest markup, byte for byte. */
  function rows(ht, orig, cmp) {
    ht = Math.round(+ht) || 0; orig = Math.round(+orig) || 0; cmp = Math.round(+cmp) || 0;
    var ttc = Math.round(ht * 1.2);
    if (orig > ht && ht > 0) {
      return '<div class="bgcom-price-ttc bgp-row2" data-samita-ttc>' + badge(Math.round((1 - ht / orig) * 100), ht) +
        '<span class="bgp-ttc"><span class="bgcom-money">' + fmt(ttc) + '</span> TTC</span></div>' +
        '<div class="bgcom-price-ht" data-samita-ht><span class="bgcom-money">' + fmt(ht) + '</span> HT ' +
        '<span class="bgcom-original-price"><s><span class="bgp-sr">au lieu de </span>' + fmt(orig) + ' HT</s></span></div>';
    }
    if (cmp > ht && ht > 0) {
      return '<div class="bgcom-price-ttc bgp-row2" data-samita-ttc>' + sale(Math.round((1 - ht / cmp) * 100)) +
        '<span class="bgp-ttc"><span class="bgcom-money">' + fmt(ttc) + '</span> TTC</span></div>' +
        '<div class="bgcom-price-ht" data-samita-ht><span class="bgcom-money">' + fmt(ht) + '</span> HT ' +
        '<span class="bgcom-original-price"><s><span class="bgp-sr">au lieu de </span>' + fmt(cmp) + ' HT</s></span></div>';
    }
    return '<div class="bgcom-price-ttc" data-samita-ttc><span class="bgcom-money">' + fmt(ttc) + '</span> TTC</div>' +
      '<div class="bgcom-price-ht" data-samita-ht><span class="bgcom-money">' + fmt(ht) + '</span> HT</div>';
  }
  window.bgcomProFmt = fmt; window.bgcomProBadge = badge; window.bgcomSaleBadge = sale; window.bgcomProRows = rows;

  /* ── one-shot sparkle ── */
  if (!('IntersectionObserver' in window) || !('MutationObserver' in window) || !d.body) return;
  var HOST = '.bgcom-samita-target, .bgcom-product-price-native, .bgcom-tref-pricecell';   /* survives innerHTML repaints */
  var SKIP = 'product-sticky-form, .bgcom-psearch__item, .bgb-price, .bgcom-qv-price, .button, #bgpro-overlay, #bgcp';
  var DENSE = '.wizard-product-item, .bgcom-tref-rem';
  var PRO = '.bgp-badge:not(.bgp-badge--sale)';                 /* a promotion pill never sparkles */
  /* the burst, in px from the star's centre: [dx, dy, size, colour]. Every star lands at least 0.5 px right of the pill's
     left edge (= the card's edge), so no card clips one; above and below, they stay within 12 px of the pill.
     COMPACT (dense rows and the sticky bar): within 9 px. */
  var W1 = '#ffb300', W2 = '#ffd54a', W3 = '#f28c00';
  var SPK = [[-8, -17, 10, W1], [9, -20, 8, W2], [28, -17, 11, W3], [-7, 17, 8, W2], [14, 19, 10, W1], [34, 16, 7, W3]];
  var SPK_C = [[-5, -14, 8, W1], [8, -16, 7, W2], [24, -14, 9, W3], [-5, 14, 7, W2], [12, 15, 8, W1], [28, 13, 6, W3]];
  var budget = 8, pending = [], raf = 0;
  function can() {
    var M = window.BGM;
    return !!(M && M.spark && !M.reduced() && !(window.Shopify && window.Shopify.designMode) && root.hasAttribute('data-bgcom-prices'));
  }
  function play(b) {
    if (!b.isConnected || b.classList.contains('is-spk') || !can()) return;
    b.classList.add('is-spk');
    /* origin = the glyph's centre in the pill's own em (padding .6em + half the 1em glyph; dense .42em + .425em): no layout read */
    var dense = b.closest(DENSE);
    window.BGM.spark(b, { x: dense ? '.85em' : '1.1em', y: '50%', sparks: (dense || b.closest('product-sticky-form')) ? SPK_C : SPK });
    setTimeout(function () { b.classList.remove('is-spk'); }, 900);
  }
  /* plays on the host's CURRENT pill: the renderer and the app can repaint the same host 2-3 times within ~300 ms (shadow
     spans re-injected, variant change); the settle window below turns that storm into ONE sparkle on the final pill.
     The price lands first: inside a BGM reveal (data-bgm-s) it waits for the reveal to hand the card back (1.6 s max). */
  function fire(host, n) {
    host._bgpT = 0;
    var b = host.querySelector(PRO);
    if (!b || !can()) return;
    if (b.closest('[data-bgm-s]') && (n || 0) < 16) { host._bgpT = setTimeout(function () { fire(host, (n || 0) + 1); }, 100); return; }
    var key = b.getAttribute('data-bgp-key') || '';
    if (key !== host.getAttribute('data-bgp-seen')) host.setAttribute('data-bgp-seen', key);   /* moved again while settling: the latest value */
    play(b);
  }
  function schedule(host, delay) {
    if (host._bgpT) clearTimeout(host._bgpT);
    host._bgpT = setTimeout(function () { fire(host, 0); }, 250 + delay);
  }
  var io = new IntersectionObserver(function (list) {
    var batch = 0;
    list.forEach(function (e) {
      if (!e.isIntersecting) return;
      var b = e.target;
      if (d.visibilityState === 'hidden') { if (pending.indexOf(b) < 0) pending.push(b); return; }
      io.unobserve(b);
      var host = b.closest(HOST) || b.parentNode, key = b.getAttribute('data-bgp-key') || '', prev = host.getAttribute('data-bgp-seen');
      if (prev === key) return;                        /* same value repainted: stays still */
      host.setAttribute('data-bgp-seen', key);
      if (!can()) return;
      if (prev !== null) { schedule(host, 0); return; } /* a NEW value on a surface already seen: always, never budgeted */
      if (budget <= 0 || batch >= 4) return;           /* first view: 4 per batch, 8 per page; the rest stay still */
      budget--; schedule(host, 90 * batch++);
    });
  }, { threshold: 1, rootMargin: '0px 0px -10% 0px' });
  function scan() {
    raf = 0;
    [].forEach.call(d.querySelectorAll(PRO + ':not([data-bgp-w])'), function (b) {
      b.setAttribute('data-bgp-w', '');
      if (!b.closest(SKIP)) io.observe(b);
    });
  }
  function queue() { if (!raf) raf = requestAnimationFrame(scan); }
  new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var a = recs[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && (n.classList.contains('bgp-badge') || (n.firstElementChild && n.querySelector('.bgp-badge')))) { queue(); return; }
      }
    }
  }).observe(d.body, { childList: true, subtree: true });
  d.addEventListener('visibilitychange', function () {
    if (d.visibilityState !== 'visible' || !pending.length) return;
    var p = pending; pending = [];
    p.forEach(function (b) { io.unobserve(b); if (b.isConnected) io.observe(b); });
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', queue); else queue();

  /* hover replay (Greg 30/09): with a mouse, the pointer ENTERING a product (its outermost container below) replays that
     product's pro pill sparkle, at most once per 1.2 s per pill, never counted in the first-view budget. Moves inside the
     same product do nothing. Never on touch (pointerType), never without a fine hovering pointer, never in reduced motion
     or in the theme editor (can(), inside play). */
  var HOVER = '.product-card, .bgcom-card-wrap, .bgb-item, .wizard-product-item, .bgcom-product-header__price, .bgcom-product-header, product-sticky-form, .bgh-card, .bgcom-qv-price';
  var mqH = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  d.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !mqH || !mqH.matches) return;
    var t = e.target, c = t && t.closest ? t.closest(HOVER) : null, top = null;
    while (c) { top = c; c = c.parentElement ? c.parentElement.closest(HOVER) : null; }
    var rel = e.relatedTarget;
    if (!top || (rel && rel.nodeType === 1 && top.contains(rel))) return;
    var now = Date.now();
    [].forEach.call(top.querySelectorAll(PRO), function (b) {
      if (now - (b._bgpH || 0) < 1200 || b.closest('.button, #bgpro-overlay, #bgcp')) return;
      /* a pill that is not painted (sticky card put away, compact phone bar, hidden row) does not sparkle */
      if (b.checkVisibility ? !b.checkVisibility({ opacityProperty: true, visibilityProperty: true }) : !b.getClientRects().length) return;
      b._bgpH = now;
      play(b);
    });
  }, { passive: true });
  window.BGP = { scan: scan, play: play, left: function () { return budget; } };
})();
